import { allFileType } from './file-constants'

const transformCode = (waterMarkInfo = []) => {
  try {
    return btoa(
      unescape(
        encodeURIComponent(
          `["${waterMarkInfo[0] || ''}","${waterMarkInfo[1] || ''}","${
            waterMarkInfo[2] || ''
          }"]`
        )
      )
    )
  } catch (e) {
    return ''
  }
}

export const getWatermarkUrl = (
  fileInfo,
  addWatermarkToImage,
  waterMarkInfo
) => {
  const { originSrc } = fileInfo
  const originEncodeUrl = encodeURIComponent(originSrc)
  // 压缩图片使用原图专为 jpg 格式后降低质量至 20%
  const thumbnailEncodeUrl = encodeURIComponent(
    `${originSrc}?x-oss-process=image${
      originSrc.indexOf('.jpg') > -1 ? '' : '/format,jpg'
    }/quality,Q_20`
  )
  const encodeText = encodeURIComponent(transformCode(waterMarkInfo))
  const originWatermarkUrl = addWatermarkToImage(
    originEncodeUrl,
    encodeText,
    10,
    'white',
    0,
    true
  )
  const thumbnailWatermarkUrl = addWatermarkToImage(
    thumbnailEncodeUrl,
    encodeText,
    10,
    'white',
    0,
    true
  )
  return {
    originWatermarkUrl,
    thumbnailWatermarkUrl,
  }
}

export const checkFile = (url) => {
  const index = url.lastIndexOf('.')
  const endIndex = url.lastIndexOf('?')
  if (index > endIndex) {
    return url.slice(index + 1)
  }
  return url.slice(index + 1, endIndex)
}

export const checkIsImage = (item) => {
  const { fileType, src, link } = item
  const extension = fileType || checkFile(src || link)

  // 根据文件格式判断要渲染格式
  const type = allFileType.filter((obj) => {
    return (
      obj.extension.indexOf(extension) > -1 ||
      obj.extension.some((v) => extension.indexOf(v) > -1) ||
      extension.indexOf(obj.key) > -1
    )
  })

  const { key } = type.length > 0 ? type[0] : {}
  return key === 'image'
}

// 根据文件格式判断要渲染格式
export const getType = (extension) => {
  const type = allFileType.filter((obj) => {
    return (
      obj.extension.indexOf(extension) > -1 ||
      obj.extension.some((v) => extension.indexOf(v) > -1) ||
      extension.indexOf(obj.key) > -1
    )
  })
  return type.length > 0 ? type[0] : {}
}
